/**
 * Admin Footer Component
 * 
 * Footer component specifically for admin interface.
 * Displays copyright information at the bottom of admin pages.
 * 
 * This footer is designed for desktop use and is always displayed horizontally
 * at the bottom of the screen.
 */
import React from 'react';

export interface AdminFooterProps {
  /** Copyright text */
  text?: string;
}

// Default copyright text for the company
const DEFAULT_COPYRIGHT = '© 2026 株式会社西行土木. All Rights Reserved';

export default function AdminFooter({ text = DEFAULT_COPYRIGHT }: AdminFooterProps) {
  // All styling is done with inline styles as per project requirements
  // Footer is always displayed horizontally at the bottom of admin pages
  return (
    <footer 
      style={{ 
        marginTop: 'auto',
        paddingTop: 20,
        paddingBottom: 20,
        textAlign: 'center',
        flexShrink: 0,
      }} 
      aria-label="Copyright"
    >
      <p 
        style={{
          fontSize: '0.75rem',
          color: '#9a9a9a',
          margin: 0,
        }}
      >
        {text}
      </p>
    </footer>
  );
}
